// hydrate an asset that has no links and therefore requires no special logic
import type { HydrationAssetError } from '../types';
import { extractTenantDetails, findScopedTenant, generateHydrationError, isActiveAsset } from './utils';
import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';
type GenericAssetType = 'contacts' | 'addresses' | 'carrierSettings';

export const hydrateGenericBaseAsset = (
  tenantList: PartnerTenant[],
  assetType: GenericAssetType,
  asset?: any,
  assetId?: string,
) => {
  const notActive = !isActiveAsset(asset) && asset ? generateHydrationError('Not configured', assetType) : null;
  const notLinked = !asset ? generateHydrationError('Not configured', assetType) : null;
  const tenant = assetId ? findScopedTenant(assetId, 'contacts', tenantList) : null;
  const errors: HydrationAssetError[] = [notActive, notLinked].filter((err): err is HydrationAssetError => !!err);
  return {
    ...(asset ?? {}),
    ...(tenant ? { tenant: extractTenantDetails(tenant) } : {}),
    validationInfo: {
      errors,
      configurationValid: !errors.length,
      warnings: [],
      configurationComplete: !errors.length,
    },
  };
};
